export enum EventSetupWizardStep {
  Unspecified = 0,
  EventDetails = 1,
  FormBuilder = 2,
  Settings = 3,
  Receipt = 4,
}
